export const CONDENSED_FONT = [
    "eurostile-condensed",
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
].join(",");
//# sourceMappingURL=condensed-fonts.js.map